export default function QuizTableHead() {
  return (
    <thead>
      <tr>
        <th className="table-th">Question</th>
        <th className="table-th">Video</th>
        <th className="table-th justify-center">Action</th>
      </tr>
    </thead>
  );
}
